import axios from 'axios'
import store from '@/store'
import { encrypt, checkDigest, decrypt } from '@/utils/crypto'
import router from '@/router'
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000 ,// request timeout
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
})
service.interceptors.request.use(
  config => {
    if (store.state.user.token) {
      config.headers['token'] = store.state.user.token
    }
    config.data = encrypt(JSON.stringify(config.data))
    if (store.state.user.token) {
      config.data['token'] = store.state.user.token
    }
    return config
  },
  error => {
     return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.data.result == -99 || response.data.code == 2) {
      store.commit('setoken', '')
      store.commit('setuser', '')
      store.commit('setphone', '')
      router.push("/sacrifice/login")
    }else{
      if (response.data.result == 0) {
        let flag = checkDigest(response.data.digest, response.data.body, response.data.ts)
        return flag ? decrypt(response.data.body,'UX00H5n2BN7L4Y5H') : false
      }
    }
  },
  error => {
    console.log( error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/sacrifice.js